import { PayloadAction } from '@reduxjs/toolkit';
import { handleResponseError } from 'app/rootSaga';
import { AxiosError } from 'axios';
import { CommonResponse } from 'models';
import { call, put, takeEvery } from 'redux-saga/effects';
import deliveryService from './deliveryService';
import { deliveryListActions } from './deliverySlice';
import { DeliveryAction, DeliveryInfo, DeliveryMasterDataInfo, DeliverySearchPayload } from './models/delivery';

function* getDeliveryMasterData() {
  try {
    const response: CommonResponse<DeliveryMasterDataInfo> = yield call(deliveryService.getDeliveryMasterData);
    yield put(deliveryListActions.fetchDeliveryMasterDataSuccess(response));
  } catch (e) {
    yield put(deliveryListActions.fetchDeliveryMasterDataFailed());
    yield handleResponseError(e as AxiosError);
  }
}

function* getDeliveryList(action: PayloadAction<DeliverySearchPayload>) {
  try {
    const response: CommonResponse<DeliveryInfo> = yield call(deliveryService.getDeliveryList, action.payload);
    yield put(deliveryListActions.fetchDeliveriesInfoSuccess(response));
  } catch (e) {
    yield put(deliveryListActions.fetchDeliveriesInfoDataFailed());
    yield handleResponseError(e as AxiosError);
  }
}

function* performWorkflowAction(
  action: PayloadAction<{
    deliveryId: number;
    action: string;
    filterSearch: DeliverySearchPayload;
    employeeJobId: number;
  }>
) {
  try {
    const response: CommonResponse<DeliveryAction> = yield call(
      deliveryService.doWorkflowAction,
      action.payload.deliveryId,
      action.payload.action,
      action.payload.employeeJobId
    );
    yield put(deliveryListActions.performWorkflowActionSuccess());
    yield put(deliveryListActions.fetchDeliveriesInfo(action.payload.filterSearch));
    yield put(deliveryListActions.fetchWorkflowActions(action.payload.deliveryId));
    if (response.data.approval_status === 'APPROVED') {
      yield put(deliveryListActions.updateIsLinkDisabled(false));
    } else {
      yield put(deliveryListActions.updateIsLinkDisabled(true));
    }
  } catch (e) {
    yield put(deliveryListActions.performWorkflowActionFailed());
    yield handleResponseError(e as AxiosError);
  }
}

function* fetchWorkflowActions(action: PayloadAction<number>) {
  try {
    const workflowResponse: CommonResponse<any> = yield call(deliveryService.getWorkflowActions, action.payload);
    yield put(deliveryListActions.fetchWorkflowActionsSuccess(workflowResponse.data.workflow_actions));
  } catch (e) {
    yield put(deliveryListActions.fetchWorkflowActionsFailed());
    yield handleResponseError(e as AxiosError);
  }
}

export default function* deliverySaga() {
  yield takeEvery(deliveryListActions.fetchDeliveriesInfo.type, getDeliveryList);
  yield takeEvery(deliveryListActions.fetchDeliveryMasterData.type, getDeliveryMasterData);
  yield takeEvery(deliveryListActions.performWorkflowAction.type, performWorkflowAction);
  yield takeEvery(deliveryListActions.fetchWorkflowActions.type, fetchWorkflowActions);
}
